module.exports = __webpack_public_path__ + "static/djar-groen-3e308eae94ef23350f6bb9c6ba4d6154.png";